import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import PlayerImage from '../../../../BaseComponents/Image/Player'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'
import FlagImage from '../../../../BaseComponents/Image/Flag'
import CaptionFont from '../../../../Theme/Fonts/Caption'
import WinningAverage from './HelperClass/WinningAverage'

export type BasicDartsWinnerProps = {
    /** imageUrl of the player image */
    playerImageUrl?: string
    /** imageAlt of the player image */
    playerImageAlt?: string
    /** name of the player */
    playerName: string
    /** imageUrl of the players country */
    countryImageUrl?: string
    /** imageAlt of the players country */
    countryImageAlt?: string
    /** three darts average of the player */
    threeDartsAverage: string
}

export type DartsWinnerProps = {
    /** the double which finished the leg */
    finishingDouble?: string
    /** number of thrown darts in this leg */
    numberOfThrows?: number
    /** quote of doubles in the set */
    doubleQuote?: string
    /** text to be displayed next to "gewonnen" */
    winningType: 'Leg' | 'Set'
} & BasicDartsWinnerProps

const DartsWinner: FunctionComponent<DartsWinnerProps> = ({
    playerImageUrl,
    playerImageAlt,
    winningType,
    countryImageUrl,
    countryImageAlt,
    playerName,
    threeDartsAverage,
    numberOfThrows,
    finishingDouble,
    doubleQuote,
}) => {
    const doubleLabel = finishingDouble || doubleQuote
    return (
        <Grid
            horizontal
            centerVertical
            paddingX={5}
            paddingY={4}
            border={1}
            backgroundColor="pearl"
            borderColor="moon-2"
            borderRadius="8px"
        >
            <Grid noExpand paddingRight={3}>
                <PlayerImage imageUrl={playerImageUrl} alt={playerImageAlt} width={30} size="L" />
            </Grid>
            <Grid>
                <SmallBodyFont bold>{`${winningType} gewonnen!`}</SmallBodyFont>
                <Grid horizontal centerVertical>
                    <Grid noExpand paddingRight={2} paddingBottom={1}>
                        <FlagImage
                            imageUrl={countryImageUrl}
                            alt={countryImageAlt}
                            width={12}
                            size="L"
                        />
                    </Grid>
                    <CaptionFont color="onyx-5">{playerName}</CaptionFont>
                </Grid>
            </Grid>
            <WinningAverage icon="average" label={threeDartsAverage} />
            {numberOfThrows ? (
                <WinningAverage icon="darts-throws" label={`${numberOfThrows}`} spaceLeft="small" />
            ) : null}
            {doubleLabel ? (
                <WinningAverage icon="darts-winner" label={doubleLabel} spaceLeft="small" />
            ) : null}
        </Grid>
    )
}
export default DartsWinner
